import { useState } from "react";
import { Modal } from "@tw/tw-common-js";
import RoleAssignmentHistory from "../audit/RoleAssignmentHistory";

export default function UserEdit({ userInit, close }) {
  const [user] = useState({ ...userInit });

  // Remove create logic and make all fields read-only except role (if allowed)
  return (
    <Modal
      close={close}
      title="User Info"
      footer={
        <div className="btn-bar-right">
          <button className="link" onClick={close}>
            Close
          </button>
        </div>
      }
    >
      <div className="modal-user-edit">
        <h2>Person Info</h2>
        <div className="label-row">
          <label>HR Code</label>
          <input value={user.hrCode || ""} readOnly />
        </div>
        <div className="label-row">
          <label>First Name</label>
          <input value={user.firstName || ""} readOnly />
        </div>
        <div className="label-row">
          <label>Last Name</label>
          <input value={user.lastName || ""} readOnly />
        </div>
        <div className="label-row">
          <label>Email</label>
          <input value={user.email || ""} readOnly />
        </div>

        <h2>Security</h2>
        <div className="label-row">
          <label>Roles</label>
          {user.roles?.map((r) => (
            <div key={r.id} className="badge">
              {r.name}
            </div>
          ))}
        </div>
        <div className="label-row">
          <label>Status</label>
          <input value={user.isArchived ? "Archived" : "Active"} readOnly />
        </div>

        <h2>Role History</h2>
        <RoleAssignmentHistory hrCode={user.hrCode} />
      </div>
    </Modal>
  );
}
